import _ from 'lodash';
import React, {FunctionComponent, ReactNode} from 'react';
import {IconButton, Modal} from '@material-ui/core';
import {CloseIcon} from '@treez-ui/core/icons';
import {Title, TitleSize} from '@treez-ui/core/layout/Title';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import ProductCard from '~/modules/widgets/products/ProductCard';
import {onBackdropClickWrap} from '~/lib/backdropClickWrap';

interface Props {
    callToAction: ReactNode;
    closeProductDetails: Function;
    product?: Partial<ProductInCatalog>;
}

const BrandProductModal: FunctionComponent<Props> = (props: Props) => {
    const {callToAction, closeProductDetails, product} = props;

    return (
        <Modal
            open={product != null}
            onClose={onBackdropClickWrap(() => closeProductDetails)}
            className="product-details-modal"
        >
            <div className="brand-product-details-container modal-body-large">
                <div className="product-details-header">
                    <div className="left-options">
                        <Title text="Add Product To Central Catalog" size={TitleSize.MEDIUM} />
                    </div>
                    <IconButton onClick={() => closeProductDetails()}>
                        <CloseIcon color="black" />
                    </IconButton>
                </div>
                {product && <ProductCard product={product} actions={[callToAction]} />}
            </div>
        </Modal>
    );
};

export default BrandProductModal;
